export const PreQualifierAssetTypeListUat = {
  title: 'preQualifierAssetTypeList.title',
  listItems: 'preQualifierAssetTypeList.listItems',
}
